import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Appointments
export const createAppointment = async (appointmentData) => {
  const response = await axios.post(`${API}/appointments`, appointmentData);
  return response.data;
};

export const getAppointments = async () => {
  const response = await axios.get(`${API}/appointments`);
  return response.data;
};

// Services
export const getServices = async () => {
  const response = await axios.get(`${API}/services`);
  return response.data;
};

// Testimonials
export const getTestimonials = async () => {
  const response = await axios.get(`${API}/testimonials`);
  return response.data;
};

// Gallery
export const getGallery = async () => {
  const response = await axios.get(`${API}/gallery`);
  return response.data;
};
